export default __webpack_public_path__ + "static/media/a7ae3340566ede98387604cd5e4de56c25927ee88f04f9f6aa540fac96a2018e.660029ee.png";